import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, forwardRef, useState, useImperativeHandle } from "react";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import AssetMapDetail from "@/components/AssetMapDetail";
import Marquee from "@/components/Marquee";
import { eamApi } from "@/api/eamApi";
import { uamApi } from "@/api/uamApi";
import { lcgApi } from "@/api/lcgApi";
const AssetMap3D = forwardRef(({ className = "", type = "eam", fontSize = 16, onPointClick }, ref) => {
    const childRef = useRef(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedAssetDetail, setSelectedAssetDetail] = useState(null);
    const [assetTitle, setAssetTitle] = useState('');
    const [cameraLock, setCameraLock] = useState(false);
    let api = { eam: eamApi, uam: uamApi, lcg: lcgApi }[type];
    useImperativeHandle(ref, () => ({
        stopRenderLoop: () => {
            childRef?.current?.stopRenderLoop?.();
        },
        renRenderLoop: () => {
            childRef?.current?.renRenderLoop?.();
        },
    }));
    const onBuildingEnter = (name, id) => {
        setAssetTitle(name);
    };
    const onBuildingLeave = (name, id) => {
        setAssetTitle('');
    };
    const onBuildingClick = async (name, id) => {
        setAssetTitle(name);
        setSelectedAsset(null);
        let res = await api.getLocation({ locationCode: id });
        let data = res.data || {};
        if (!data)
            return false;
        let { pusingLocation = '', usingLocation = '', count = 0, assetList = [] } = data;
        setSelectedAsset({
            id: id,
            name: name,
            description: pusingLocation + usingLocation,
            count,
            detail: assetList.length ? {
                label: '资产详情单',
                list: assetList.map((item) => {
                    return {
                        id: item.assetId,
                        name: item.assetCode,
                        value: item.assetName,
                        spec: item.spec
                    };
                })
            } : null
        });
    };
    const onCameraFocus = () => {
        setCameraLock(true);
    };
    const onCameraBlur = () => {
        setSelectedAsset(null);
        setCameraLock(false);
        setAssetTitle('');
    };
    const handlePoint = (pointInfo) => {
        let { pointId, pointName, pointData } = pointInfo;
        if (pointData)
            onPointClick(pointInfo);
        else {
            onBuildingClick(pointName, pointId);
        }
    };
    const handlePointDetail = (data) => {
        console.log(data);
    };
    return (_jsxs("div", { style: { width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }, children: [_jsx(AssetMapDetail, { ref: childRef, className: "h-full", jsonUrl: "assets/models/minhang.json", fontSize: fontSize, onBuildingEnter: onBuildingEnter, onBuildingLeave: onBuildingLeave, onBuildingClick: onBuildingClick, onCameraFocus: onCameraFocus, onCameraBlur: onCameraBlur, onPointClick: handlePoint }), cameraLock && (_jsx("div", { className: "absolute top-1 left-1", children: _jsx(Button, { style: { background: '#fff', color: '#000' }, onClick: () => { childRef?.current?.cameraBlur?.(); }, size: "large", color: "default", variant: "solid", shape: "circle", icon: _jsx(ArrowLeftOutlined, {}) }) })), selectedAsset && (_jsx("div", { className: "absolute z-20 p-1 text-white border bg-gray-900/38 border-gray-600/0 min-w-12", style: { animation: 'fadeInRight 1s both', borderRadius: '.2rem', top: '0.1rem', right: 'calc(40px + 0.2rem)' }, children: _jsxs("div", { className: "text-xs", style: { fontSize: `${fontSize / 100}rem`, lineHeight: 1.5 }, children: [selectedAsset.name && (_jsxs("div", { className: "flex", style: { marginBottom: '.05rem' }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon01.png", style: { width: '.2rem', height: '.21rem', marginRight: '.1rem' } }), "\u697C\u5C42\uFF1A"] }), _jsx("span", {})] })), selectedAsset.name && (_jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u5EFA\u7B51\u540D\u79F0\uFF1A" }), _jsx("span", { children: selectedAsset.name })] })), _jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u7269\u8D44\u603B\u6570\uFF1A" }), _jsxs("span", { children: [selectedAsset.count || 0, "\u4E2A"] })] }), selectedAsset.detail && (_jsxs("div", { className: "flex", style: { margin: '.05rem 0' }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon02.png", style: { width: '.12rem', height: '.12rem', marginRight: '.1rem' } }), selectedAsset.detail.label, "\uFF1A"] }), _jsx("span", {})] })), selectedAsset.detail && _jsx(Marquee, { animate: selectedAsset.detail.list.length > 8, duration: selectedAsset.detail.list.length * 1.25, children: selectedAsset.detail.list.map((d, i) => {
                                return (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: d.name ? d.name + ':' : '' }), _jsx("span", { children: d.value })] }, i));
                            }) })] }) })), assetTitle && (_jsx("div", { className: "absolute top-[0.1rem] z-20 text-white transform -translate-x-1/2 border left-1/2 bg-gray-900/38 border-gray-600/0 min-w-1", style: { padding: '.1rem', borderRadius: '.1rem' }, children: _jsx("div", { style: { fontSize: `${fontSize / 100}rem` }, children: assetTitle }) }))] }));
});
export default AssetMap3D;
